import {
  Flex,
  Box,
  VStack,
  Text,
  HStack,
  Button,
  Center,
  keyframes,
  usePrefersReducedMotion,
} from "@chakra-ui/react";
import MainFooter from "components/Layout/MainFooter";
import GCPImage from "components/GCPImage";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useRouter } from "next/router";
import Calltoaction from "components/Calltoaction";

const COMMENT1 = [
  {
    name: "彭小姐",
    content:
      "送還車專員非常細心，人也很親切。總是會提早到達，很棒！客服也總是將客戶的問題處理妥善，應答得宜，也很棒！",
    icon: "/images/about/person1.jpg",
  },
  {
    name: "鄭先生",
    content:
      "車輛非常乾淨！交車時人員親切解說，並過程中都很認真告知注意事項，很棒的客服人員。",
    icon: "/images/about/person2.jpg",
  },
  {
    name: "沈先生",
    content:
      "各項流程都比其他業者方便簡單，從下訂到取車還車都非常棒。相較於其他企業更像是跟好友借車一樣，非常優秀，請繼續保持👍",
    icon: "/images/about/person3.jpg",
  },
  {
    name: "Tan Wei Jian",
    content: "車子的品質很ok，服務都很棒，回復信息速度也很快。",
    icon: "/images/about/person4.jpg",
  },
  {
    name: "陳先生",
    content:
      "車輛品質很好，交車/還車過程愉快迅速。給五星好評，後續如有需要會再繼續使用相關服務，希望可以增加更多站點(如中南部)。",
    icon: "/images/about/person5.jpg",
  },
];
const COMMENT2 = [
  {
    name: "劉先生",
    content: "車輛整潔、完整，預約流程快速且方便，送車人員講解詳細且非常準時。",
    icon: "/images/about/person6.jpg",
  },
  {
    name: "Marcel Weidmann",
    content:
      "Vehicle was in perfect condition👍 The guy was really nice, friendly. Perfect English. Really helpful.",
    icon: "/images/about/person7.jpg",
  },
  {
    name: "郭先生",
    content:
      "新的model Y，新的體驗，覺得很好，送還車的員工清楚詳細解說，貼心囑咐車型的差異與功能！",
    icon: "/images/about/person8.jpg",
  },
  {
    name: "陳先生",
    content: "It was wonderful experience , Good service, Good quality.",
    icon: "/images/about/person9.jpg",
  },
  {
    name: "丁先生",
    content:
      "Andy的第一次服務很好，讓我本來完全沒開過特斯拉的緊張感完全放鬆，車子性能真的很好，服務很專業，專員也提前到現場等待。",
    icon: "/images/about/person10.jpg",
  },
];

const Block1 = () => {
  const { t } = useTranslation("common");
  return (
    <Flex flexDir={{ base: "column", md: "row" }} bg="#3374F6">
      <VStack flex="1 1 50%" display="flex" align="center" justify="center">
        <Box mx="16px">
          <Text
            fontSize={{ base: "32px", md: "64px" }}
            fontWeight="700"
            lineHeight={{ base: "40px", md: "80px" }}
            color="#FFFFFF"
            mt={{ base: "40px", md: "0px" }}
            mb="8px"
          >
            {t("Header_btn1_aboutUdrive")}
          </Text>
          <Text
            maxW="400px"
            fontSize={{ base: "16px", md: "20px" }}
            fontWeight="700"
            lineHeight={{ base: "24px", md: "28px" }}
            color="#FFFFFF"
            mb="40px"
          >
            {t("AboutUs_sec1_subtitle")}
          </Text>
          <Text
            maxW="360px"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            color="#FFFFFF"
          >
            {t("AboutUs_sec1_infotext")}
          </Text>
        </Box>
      </VStack>
      <Box
        display="flex"
        justifyContent={{ base: "end", md: "start" }}
        alignItems="end"
        flex={{ base: "1 1 272px", md: "1 1 50%" }}
        mb={{ base: "0px", md: "45px" }}
        mt={{ base: "0px", md: "82px" }}
      >
        <GCPImage
          maxW={{ base: "272px", md: "full" }}
          alt="圖片"
          src="/images/about/aboutImg1.svg"
        />
      </Box>
    </Flex>
  );
};

const Block2 = () => {
  const { t } = useTranslation("common");
  return (
    <Flex flexDir={{ base: "column", md: "row" }} bg="#ffffff">
      <Box
        display="flex"
        justifyContent={{ base: "center", md: "center" }}
        alignItems="end"
        flex={{ base: "1 1 auto", md: "1 1 60%" }}
        mt={{ base: "58px", md: "120px" }}
        mb={{ base: "40px", md: "150px" }}
      >
        <GCPImage
          maxW={{ base: "272px", md: "full" }}
          alt="圖片"
          src="/images/about/aboutImg2.svg"
        />
      </Box>
      <VStack flex="1 1 40%" display="flex" align="start" justify="center">
        <Box mx={{ base: "16px", md: "0px" }} mb={{ base: "40px", md: "0px" }}>
          <Text
            maxW="480px"
            fontSize={{ base: "24px", md: "40px" }}
            fontWeight="700"
            lineHeight={{ base: "32px", md: "48px" }}
            color="#3374F6"
            mb="40px"
          >
            {t("AboutUs_sec2_title")}
          </Text>
          <Text
            maxW="420px"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            color="#333333"
          >
            {t("AboutUs_sec2_infotext")}
          </Text>
        </Box>
      </VStack>
    </Flex>
  );
};

const Card = ({ name, content, icon }) => {
  return (
    <Box borderRadius="16px" overflow="hidden">
      <Box
        w="280px"
        h="184px"
        borderLeftWidth="4px"
        borderColor="#3374F6"
        bg="#ffffff"
      >
        <Box p="12px" pr="10px">
          <Flex align="center">
            <GCPImage w="40px" h="40px" alt="icon" src={icon} />
            <Text
              ml="8px"
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color="#333333"
            >
              {name}
            </Text>
          </Flex>
          <Text
            mt="16px"
            fontSize="16px"
            fontWeight="700"
            lineHeight="22px"
            color="#748598"
          >
            {content}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

const CustomerFeedback = () => {
  const { t } = useTranslation("common");
  const moveup1 = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
  `;
  const moveup2 = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(50%); }
  `;

  const preferReducedMotion = usePrefersReducedMotion();
  const animation1 = preferReducedMotion
    ? undefined
    : `${moveup1} 30s linear 0s infinite`;
  const animation2 = preferReducedMotion
    ? undefined
    : `${moveup2} 30s linear 0s infinite`;

  return (
    <Box
      bg="#E9EAEF"
      justify="center"
      overflow="hidden"
      h={{ base: "560px", md: "656px" }}
    >
      <Box mt={{ base: "40px", md: "80px" }} mb="40px">
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          fontWeight="700"
          lineHeight={{ base: "32px", md: "48px" }}
          color="#333333"
        >
          {t("AboutUs_sec3_title")}
        </Text>
      </Box>
      <Box mt="40px" pos="relative" left="0" top="0" bg="pink">
        <Flex pos="absolute" direction="row" animation={animation1}>
          {[...COMMENT1, ...COMMENT1].map((item, index) => {
            return (
              <Box mx="40px" key={index}>
                <Card
                  name={item.name}
                  content={item.content}
                  icon={item.icon}
                />
              </Box>
            );
          })}
        </Flex>
      </Box>
      <Box
        mb="40px"
        pos="relative"
        right="0"
        top="220px"
        display="flex"
        justifyContent="flex-end"
      >
        <Flex pos="absolute" flexDir="row-reverse" animation={animation2}>
          {[...COMMENT2, ...COMMENT2].map((item, index) => {
            return (
              <Box mx="40px" key={index}>
                <Card
                  name={item.name}
                  content={item.content}
                  icon={item.icon}
                />
              </Box>
            );
          })}
        </Flex>
      </Box>
    </Box>
  );
};

const Block3 = () => {
  const { t } = useTranslation("common");
  return (
    <Flex justify="center">
      <Box mt={{ base: "40px", md: "80px" }} mb={{ base: "40px", md: "48px" }}>
        <Center
          mb={{ base: "40px", md: "80px" }}
          fontSize={{ base: "24px", md: "40px" }}
          fontWeight="700"
          lineHeight={{ base: "32px", md: "48px" }}
        >
          <Text>UDRIVE </Text>
          <Text color="#3374F6">{t("AboutUs_sec4_title_p2")}</Text>
        </Center>

        <HStack
          flexDir={{ base: "column", md: "row" }}
          spacing={{ base: "0px", md: "80px" }}
        >
          <VStack>
            <Text
              mb={{ base: "8px", md: "16px" }}
              fontSize={{ base: "20px", md: "24px" }}
              fontWeight="700"
              lineHeight={{ base: "28px", md: "32px" }}
              color="#333333"
            >
              {t("AboutUs_sec4_subtitle1")}
            </Text>

            <Box pb={{ base: "16px", md: "40px" }}>
              <GCPImage alt="icon" src="/images/about/rectangle3.svg" />
            </Box>
            <GCPImage alt="文件" src="/images/about/license1.jpg" />
            <Text
              mt="8px"
              fontSize="12px"
              fontWeight="400"
              lineHeight="20px"
              color="#748598"
            >
              {t("AboutUs_sec4_caption1")}
            </Text>
          </VStack>
          <VStack>
            <Text
              mt={{ base: "40px", md: "0px" }}
              mb={{ base: "8px", md: "16px" }}
              fontSize={{ base: "20px", md: "24px" }}
              fontWeight="700"
              lineHeight={{ base: "28px", md: "32px" }}
              color="#333333"
            >
              {t("AboutUs_sec4_subtitle2")}
            </Text>
            <Box pb={{ base: "16px", md: "40px" }}>
              <GCPImage alt="icon" src="/images/about/rectangle3.svg" />
            </Box>
            <GCPImage alt="文件" src="/images/about/license2.jpg" />
            <Text
              mt="8px"
              fontSize="12px"
              fontWeight="400"
              lineHeight="20px"
              color="#748598"
            >
              {t("AboutUs_sec4_caption2")}
            </Text>
          </VStack>
        </HStack>
      </Box>
    </Flex>
  );
};

const Block4 = () => {
  const { t } = useTranslation("common");
  const router = useRouter();
  return (
    <Flex flexDir={{ base: "column", md: "row" }} bg="#E9EAEF">
      <Box
        display="flex"
        justifyContent={{ base: "center", md: "center" }}
        alignItems="end"
        flex={{ base: "1 1 auto", md: "1 1 60%" }}
        mt={{ base: "58px", md: "120px" }}
        mb={{ base: "40px", md: "150px" }}
      >
        <GCPImage
          maxW={{ base: "272px", md: "full" }}
          alt="圖片"
          src="/images/about/aboutImg3.svg"
        />
      </Box>
      <VStack
        flex="1 1 40%"
        display="flex"
        align="start"
        justify="center"
        ml={{ base: "40px", md: "0px" }}
      >
        <Box mx={{ base: "16px", md: "0px" }} mb={{ base: "40px", md: "0px" }}>
          <Box mb="16px">
            <GCPImage alt="icon" src="/images/about/rectangle1.svg" />
            <GCPImage alt="icon" mt="4px" src="/images/about/rectangle2.svg" />
          </Box>
          <Text
            fontSize={{ base: "24px", md: "40px" }}
            fontWeight="700"
            lineHeight={{ base: "32px", md: "48px" }}
            color="#333333"
            mb="40px"
          >
            {t("AboutUs_sec5_title")}
          </Text>
          <Button
            bg="#3374F6"
            color="#ffffff"
            onClick={() => {
              router.push({
                pathname: "/blog/1227-udrive-recruiting-partners",
                query: router.query,
              });
            }}
          >
            {t("AboutUs_sec5_btn")}
          </Button>
        </Box>
      </VStack>
    </Flex>
  );
};

const Block5 = () => {
  const { t } = useTranslation("common");
  const router = useRouter();
  return (
    <Flex flexDir={{ base: "column", md: "row" }}>
      <VStack
        flex="1 1 50%"
        display="flex"
        align="center"
        justify="center"
        bg="#333333"
        backgroundImage="https://storage.googleapis.com/udrive-web/images/about/bgImg1.png"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        h="384px"
        textAlign="center"
      >
        <Box my="40px">
          <Text
            fontSize={{ base: "20px", md: "40px" }}
            fontWeight="700"
            lineHeight={{ base: "28px", md: "48px" }}
            color="#FFFFFF"
            mb={{ base: "16px", md: "40px" }}
          >
            {t("AboutUs_sec6_title")}
          </Text>
          <Text
            maxW="480px"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            color="#FFFFFF"
            mb="40px"
            mx="16px"
          >
            {t("AboutUs_sec6_infotext")}
          </Text>
          <Button
            bg="#3374F6"
            color="#ffffff"
            onClick={() => {
              router.push({ pathname: "/login", query: router.query });
            }}
          >
            {t("AboutUs_sec6_btn")}
          </Button>
        </Box>
      </VStack>
      <VStack
        flex="1 1 50%"
        display="flex"
        align="center"
        justify="center"
        textAlign="center"
        pos="relative"
      >
        <Box my="40px">
          <Box pos="absolute" right="0" bottom="0">
            <GCPImage
              w={{ base: "150px", md: "300px" }}
              alt="icon"
              src="/images/about/bgCar.png"
            />
          </Box>
          <Text
            fontSize={{ base: "20px", md: "40px" }}
            fontWeight="700"
            lineHeight={{ base: "28px", md: "48px" }}
            color="#333333"
            mb={{ base: "16px", md: "40px" }}
          >
            {t("AboutUs_sec7_title")}
          </Text>
          <Text
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            color="#333333"
            mb="40px"
            maxW="480px"
            mx="16px"
          >
            {t("AboutUs_sec7_infotext")}
          </Text>
          <Button
            borderWidth="2px"
            borderColor="#3374F6"
            variant="outline"
            bg="#ffffff"
            color="#3374F6"
            onClick={() => {
              window.open("https://lin.ee/NtDKQmU", "_blank");
            }}
          >
            {t("AboutUs_sec7_btn")}
          </Button>
        </Box>
      </VStack>
    </Flex>
  );
};

function About() {
  const router = useRouter();
  return (
    <>
      <Head>
        <title key="title">認識 UDRIVE</title>
        <meta
          key="description"
          name="description"
          content="歡迎來到UDRIVE悠駕租車，我們是USPACE於2021年新成立的電動車租車事業體，不僅秉持著提供最優質服務的承諾，同時致力於實現創新與技術的完美結合。

          UDRIVE悠駕租車專注於提供特斯拉租車服務。所有車輛都經過嚴格挑選，保證車況均保持最佳狀態，為您帶來無與倫比的駕駛體驗。"
        />
      </Head>
      <Calltoaction
        href={{
          pathname: "/station",
          query: router.query,
        }}
      />
      <Block1 />
      <Block2 />
      <CustomerFeedback />
      <Block3 />
      <Block4 />
      <Block5 />
      <MainFooter />
    </>
  );
}
export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
export default About;
